import { render, staticRenderFns } from "./checkout-info.vue?vue&type=template&id=5d18050f&scoped=true"
import script from "./checkout-info.vue?vue&type=script&lang=js"
export * from "./checkout-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d18050f",
  null
  
)

export default component.exports